import { useEffect } from "react";

export default function useSeo(title, description) {
  useEffect(() => {
    document.title = `${title} | TalentBridge Consulting`;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = description;
      document.head.appendChild(meta);
    }
  }, [title, description]);
}